import { render, staticRenderFns } from "./SubCardSideControl.vue?vue&type=template&id=aa6a2ef6&scoped=true&"
import script from "./SubCardSideControl.vue?vue&type=script&lang=js&"
export * from "./SubCardSideControl.vue?vue&type=script&lang=js&"
import style0 from "./SubCardSideControl.vue?vue&type=style&index=0&id=aa6a2ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a2ef6",
  null
  
)

export default component.exports